import { KYMW2000Model } from '../kymw2000.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 注文コード割当確認一覧出力
 *
 * @export OutputPlanOrderNumQuotaSelectedSummaryService
 * @class OutputPlanOrderNumQuotaSelectedSummaryService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class OutputPlanOrderNumQuotaSelectedSummaryService extends PlessJsonResponderSub<any> {

  private model: KYMW2000Model = null;
  private calbak: (data: any) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputPlanOrderNumQuotaSelectedSummaryService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        OutputPlanOrderNumQuotaSelectedSummary: {
          condition: {
            MediumType: this.model.mediumType,
            OrderCode: this.model.orderCode,
            OrderNumQuotaCode: this.model.orderNumQuota,
            MultiPublishFlg: this.model.multiPublishFlg
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW2000Model} model 処理に使用するモデル
   * @param {Function} [successFunc=null] 成功時に実行される処理
   * @memberof OutputPlanOrderNumQuotaSelectedSummaryService
   */
  execute(model: KYMW2000Model, f?: (data: string) => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('outputPlanOrderNumQuotaSelectedSummary', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof OutputPlanOrderNumQuotaSelectedSummaryService
   */
  success(data: any): void {
    if (this.calbak) this.calbak(data);
  }
}
